// extracted by mini-css-extract-plugin
export default {"item-list":"MainsDesktop_item-list__7jiEH","item":"MainsDesktop_item__OIrU5","main-section":"MainsDesktop_main-section__6A2AI","mains-subtitle":"MainsDesktop_mains-subtitle__KG6kB"};